// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__f83Ia","title":"AfterFrontImage_title__wVBCn"};